export default {"src":"https://static.jusbr.com/web/auth/_next/static/media/confirm-email.6d972cfd.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};